import { combineReducers } from 'redux';

import reducers from './reducers';
import tileView from './tileView/tileViewSlice';
import notification from './notification/notificationSlice';
import tileForm from './tileForm/tileFormSlice';
import currentBoard from './currentBoard/currentBoardSlice';
import currentUser from './currentUser/currentUserSlice';
import navBarCollapse from './navBarCollapse/navBarCollapseSlice';
import campaignDnd from './campaignDnd/campaignDndSlice';
import campaignFormDirty from './campaignFormDirty/campaignFormDirtySlice';
import campaignPrize from './campaignPrize/campaignPrizeSlice';
import campaignScroll from './campaignScroll/campaignScrollSlice';
import selectedCampaign from './selectedCampaign/selectedCampaignSlice';
import campaignCalendar from './campaignCalendar/campaignCalendarSlice';
import campaignFilter from './campaignFilter/campaignFilterSlice';
import campaignPreview from './campaignPreview/campaignPreviewSlice';

export default combineReducers({
  ...reducers,
  tileView,
  tileForm,
  notification,
  currentBoard,
  currentUser,
  navBarCollapse,
  campaignDnd,
  campaignFormDirty,
  campaignPrize,
  campaignScroll,
  selectedCampaign,
  campaignCalendar,
  campaignFilter,
  campaignPreview,
});
